import React from 'react'

import { formatPhone } from '../../utils/PhoneUtils'

const PhoneInput = ({ value, onChange, onBlur, ...props }) => {
  const handleBlur = e => {
    // Call the original onBlur if provided
    if (onBlur) {
      onBlur(e)
    }

    const val = e.target.value
    const formatted = formatPhone(val)

    if (val !== formatted) {
      // Trigger onChange with the formatted value to update the state
      // We construct a synthetic event-like object as expected by DetailsPage.js logic
      const syntheticEvent = {
        target: {
          name: props.name,
          value: formatted,
          type: 'tel',
        },
      }
      onChange(syntheticEvent)
    }
  }

  // Always display formatted value
  const displayValue = formatPhone(value)

  return <input type="tel" value={displayValue} onChange={onChange} onBlur={handleBlur} {...props} />
}

export default PhoneInput
